module.exports = __webpack_public_path__ + "img/drive.48ff6189.png";